import { z } from 'zod';

import { reportTypeSchema } from '../reports/types';

import { isAnyObject, isEmptyObject } from '~/utils/zod-schema';
export const caseHandlerSchema = z.object({
  full_name: z.string().nullish(),
  user_type: z.number(),
  id: z.number(),
});
export type CaseHandler = z.infer<typeof caseHandlerSchema>;

export const scheduledMeetingSchema = z.object({
  id: z.number(),
  created_by: z.preprocess(
    (v) => {
      if (isAnyObject(v)) {
        return isEmptyObject(v) ? undefined : v;
      } else {
        return undefined;
      }
    },
    z
      .object({
        full_name: z.string().nullish(),
        user_type: z.number(),
        id: z.number(),
      })
      .optional(),
  ),
  link: z.string().nullish(),
  date_and_time: z.string().datetime(),
  type: z.number(),
  report: z.object({
    id: z.string(),
    report_type: reportTypeSchema,
    country_verbose: z
      .object({
        code: z.string(),
        name: z.string().nullish(),
      })
      .optional(),
  }),
  created_at: z.string().datetime(),
  address: z.string().nullable(),
  room: z.string().nullable(),
  instructions: z.string().nullable(),
  attendees: z
    .array(
      z.object({
        attendee: z.object({
          full_name: z.string().nullable(),
          user_type: z.number(),
        }),
        confirm: z.number(),
      }),
    )
    .catch([]),
  case_handler: z.preprocess(
    /**
     * Since this property can recieve an empty object ({})
     * we "preprocess" the value to force it to be undefined so we can't
     * accidentally use the value without checking if it exists
     */
    (v) => {
      if (isAnyObject(v)) {
        return isEmptyObject(v) ? undefined : v;
      }
      return v;
    },
    caseHandlerSchema.optional(),
  ),
  guest_attendees_count: z.number(),
  guest_attendees: z.array(z.string()).nullable(),
});
export type ScheduledMeeting = z.infer<typeof scheduledMeetingSchema>;

export const DateAvailabilitySchema = z.object({
  id: z.number().nullable(),
  date_start: z.string().datetime(),
  date_end: z.string().datetime(),
  time_slots: z.array(
    z.object({
      id: z.number().nullable(),
      from: z.string(),
      to: z.string(),
    }),
  ),
  weekdays: z.array(z.number()),
  duration: z.string(),
  duration_type: z.number(),
  tenant: z.number(),
  type: z.number(),
  is_excluded: z.boolean(),
});
export type DateAvailability = z.infer<typeof DateAvailabilitySchema>;
